(() => {

  const instances = new Map();

  function initHeroSlider(section) {

    if (!section) return;

    const viewport = section.querySelector('.hero-slider__viewport');
    const prevBtn = section.querySelector('.hero-slider__arrow--prev');
    const nextBtn = section.querySelector('.hero-slider__arrow--next');
    const dotsContainer = section.querySelector('.hero-slider__dots');

    if (!viewport) return;

    const slides = section.querySelectorAll('.hero-slider__slide');

    if (slides.length <= 1) return;

    if (instances.has(section)) {
      instances.get(section).destroy();
      instances.delete(section);
    }

    const autoplay =
      section.dataset.autoplay === 'true';

    const delay =
      parseInt(section.dataset.delay) || 5000;

    const loop =
      section.dataset.loop === 'true';

    const embla = EmblaCarousel(viewport, {
      loop,
      align: 'start',
      containScroll: 'trimSnaps',
      dragFree: false
    });

    instances.set(section, embla);

    /* -------------------------
       Flechas
    -------------------------- */

    function updateButtons() {

      if (prevBtn) {
        prevBtn.disabled = !embla.canScrollPrev();
      }

      if (nextBtn) {
        nextBtn.disabled = !embla.canScrollNext();
      }

    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        embla.scrollPrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        embla.scrollNext();
      });
    }

    embla.on('select', updateButtons);
    embla.on('init', updateButtons);

    /* -------------------------
       Dots
    -------------------------- */

    if (dotsContainer) {

      const snaps = embla.scrollSnapList();

      dotsContainer.innerHTML = '';

      snaps.forEach((_, index) => {

        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'hero-slider__dot';

        dot.addEventListener('click', () => {
          embla.scrollTo(index);
        });

        dotsContainer.appendChild(dot);

      });

      const dots =
        dotsContainer.querySelectorAll('.hero-slider__dot');

      function updateDots() {

        dots.forEach((dot, index) => {

          dot.classList.toggle(
            'is-selected',
            index === embla.selectedScrollSnap()
          );

        });

      }

      embla.on('select', updateDots);
      embla.on('init', updateDots);

      updateDots();

    }

    /* -------------------------
       Autoplay
    -------------------------- */

    let timer = null;

    function stopAutoplay() {

      if (timer) {
        clearInterval(timer);
        timer = null;
      }

    }

    function startAutoplay() {

      if (!autoplay) return;

      stopAutoplay();

      timer = setInterval(() => {

        if (embla.canScrollNext()) {

          embla.scrollNext();

        } else if (loop) {

          embla.scrollTo(0);

        }

      }, delay);

    }

    startAutoplay();

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    embla.on('pointerDown', stopAutoplay);
    embla.on('pointerUp', startAutoplay);

  }

  /* -------------------------
     Inicializar
  -------------------------- */

  function initAll() {

    document
      .querySelectorAll('.hero-slider')
      .forEach(initHeroSlider);

  }

  document.addEventListener(
    'DOMContentLoaded',
    initAll
  );

  /* -------------------------
     Shopify Theme Editor
  -------------------------- */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      const section =
        event.target.querySelector('.hero-slider');

      if (section) {
        initHeroSlider(section);
      }

    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {

      const section =
        event.target.querySelector('.hero-slider');

      if (!section) return;

      if (instances.has(section)) {

        instances.get(section).destroy();
        instances.delete(section);

      }

    }
  );

})();